import { useQuery } from '@shared/modules/use-query/hooks'
import { DepartmentSelect } from '../types'
import { useCallback, useMemo } from 'react'
import { DepartmentsService } from '../services'

export const useDepartmentList = () => {
  return useQuery<DepartmentSelect[]>(
    useCallback(async () => {
      const result = await DepartmentsService.getSelect()

      if (result.status === 200) {
        return result.data
      } else {
        return []
      }
    }, []),
    useMemo(() => ({ initialData: [] }), []),
  )
}
